import {useParams} from 'react-router-dom';
import {useAccountContext} from '../contexts/AccountContext';
import validateUUID from '../utils/validateUUID';

const useAccountId = () => {
  const params = useParams();
  const id: string | undefined = params?.accountId;
  const {account} = useAccountContext();

  // Return an account ID from these two sources in this order:
  // 1. URL parameter
  // 2. Application state
  // Note: the application state will mirror the URL parameter on the next cycle
  return {accountId: validateUUID(account?.id || id)};
};

export default useAccountId;
